import logisticTripsService from "../shared/services/logisticTripsService";

const REQUEST_LOGISTIC_TRIPS = "REQUEST_LOGISTIC_TRIPS";
const RESPONSE_LOGISTIC_TRIPS = "RESPONSE_LOGISTIC_TRIPS";
const REQUEST_LOGISTIC_TRIPS_FAILURE = "REQUEST_LOGISTIC_TRIPS_FAILURE";

const requestLogisticTripsAction = () => {
  return {
    type: REQUEST_LOGISTIC_TRIPS,
  };
};

const responseLogisticTripsAction = (data) => {
  return {
    type: RESPONSE_LOGISTIC_TRIPS,
    data,
  };
};

const requestLogisticTripsFailureAction = (errors) => {
  return {
    type: REQUEST_LOGISTIC_TRIPS_FAILURE,
    errors,
  };
};

const getLogisticTrips = (options = {}) => {
  return (dispatch) => {
    dispatch(requestLogisticTripsAction());

    options.orderBy = "title";

    logisticTripsService
      .getLogisticTrips(options)
      .then((result) => {
        dispatch(responseLogisticTripsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestLogisticTripsFailureAction(error.response));
      });
  };
};

const REQUEST_LOGISTIC_TRIP = "REQUEST_LOGISTIC_TRIP";
const RESPONSE_LOGISTIC_TRIP = "RESPONSE_LOGISTIC_TRIP";
const REQUEST_LOGISTIC_TRIP_FAILURE = "REQUEST_LOGISTIC_TRIP_FAILURE";

const requestLogisticTripAction = () => {
  return {
    type: REQUEST_LOGISTIC_TRIP,
  };
};

const responseLogisticTripAction = (data) => {
  return {
    type: RESPONSE_LOGISTIC_TRIP,
    data,
  };
};

const requestLogisticTripFailureAction = (errors) => {
  return {
    type: REQUEST_LOGISTIC_TRIP_FAILURE,
    errors,
  };
};

const getLogisticTrip = (options) => {
  return (dispatch) => {
    dispatch(requestLogisticTripAction());

    logisticTripsService
      .getLogisticTrip(options)
      .then((result) => {
        dispatch(responseLogisticTripAction(result.data));
      })
      .catch((error) => {
        dispatch(requestLogisticTripFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_LOGISTIC_TRIP = "REQUEST_CREATE_LOGISTIC_TRIP";
const RESPONSE_CREATE_LOGISTIC_TRIP = "RESPONSE_CREATE_LOGISTIC_TRIP";
const REQUEST_CREATE_LOGISTIC_TRIP_FAILURE = "REQUEST_CREATE_LOGISTIC_TRIP_FAILURE";

const requestCreateLogisticTripAction = () => {
  return {
    type: REQUEST_CREATE_LOGISTIC_TRIP,
  };
};

const responseCreateLogisticTripAction = (data) => {
  return {
    type: RESPONSE_CREATE_LOGISTIC_TRIP,
    data,
  };
};

const requestCreateLogisticTripFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_LOGISTIC_TRIP_FAILURE,
    errors,
  };
};

const createLogisticTrip = (options) => {
  return (dispatch) => {
    dispatch(requestCreateLogisticTripAction());

    logisticTripsService
      .createLogisticTrip(options)
      .then((result) => {
        options.id = result.data.id;
        options.alarm = result.data.alarm;
        dispatch(responseCreateLogisticTripAction(options));
      })
      .catch((error) => {
        dispatch(requestCreateLogisticTripFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_LOGISTIC_TRIP = "REQUEST_DELETE_LOGISTIC_TRIP";
const RESPONSE_DELETE_LOGISTIC_TRIP = "RESPONSE_DELETE_LOGISTIC_TRIP";
const REQUEST_DELETE_LOGISTIC_TRIP_FAILURE = "REQUEST_DELETE_LOGISTIC_TRIP_FAILURE";

const requestDeleteLogisticTripAction = () => {
  return {
    type: REQUEST_DELETE_LOGISTIC_TRIP,
  };
};

const responseDeleteLogisticTripAction = (data) => {
  return {
    type: RESPONSE_DELETE_LOGISTIC_TRIP,
    data,
  };
};

const requestDeleteLogisticTripFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_LOGISTIC_TRIP_FAILURE,
    errors,
  };
};

const deleteLogisticTrip = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteLogisticTripAction());

    logisticTripsService
      .deleteLogisticTrip(options)
      .then((result) => {
        dispatch(responseDeleteLogisticTripAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteLogisticTripFailureAction(error.response));
      });
  };
};

const ON_SELECT_LOGISTIC_TRIP = "ON_SELECT_LOGISTIC_TRIP";

const onSelectLogisticTripAction = (data) => {
  return {
    type: ON_SELECT_LOGISTIC_TRIP,
    data,
  };
};

const selectLogisticTrip = (data) => {
  return (dispatch) => {
    dispatch(onSelectLogisticTripAction(data));
  };
};

const REQUEST_UPDATE_LOGISTIC_TRIP = "REQUEST_UPDATE_LOGISTIC_TRIP";
const RESPONSE_UPDATE_LOGISTIC_TRIP = "RESPONSE_UPDATE_LOGISTIC_TRIP";
const REQUEST_UPDATE_LOGISTIC_TRIP_FAILURE = "REQUEST_UPDATE_LOGISTIC_TRIP_FAILURE";

const requestUpdateLogisticTripAction = () => {
  return {
    type: REQUEST_UPDATE_LOGISTIC_TRIP,
  };
};

const responseUpdateLogisticTripAction = (data) => {
  return {
    type: RESPONSE_UPDATE_LOGISTIC_TRIP,
    data,
  };
};

const requestUpdateLogisticTripFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_LOGISTIC_TRIP_FAILURE,
    errors,
  };
};

const updateLogisticTrip = (options) => {
  return (dispatch) => {
    dispatch(requestUpdateLogisticTripAction());

    logisticTripsService
      .updateLogisticTrip({ id: options.id, title: options.title, description: options.description })
      .then((result) => {
        dispatch(responseUpdateLogisticTripAction(options));
      })
      .catch((error) => {
        dispatch(requestUpdateLogisticTripFailureAction(error.response));
      });
  };
};

const REQUEST_COPY_LOGISTIC_TRIP = "REQUEST_COPY_LOGISTIC_TRIP";
const RESPONSE_COPY_LOGISTIC_TRIP = "RESPONSE_COPY_LOGISTIC_TRIP";
const REQUEST_COPY_LOGISTIC_TRIP_FAILURE = "REQUEST_COPY_LOGISTIC_TRIP_FAILURE";

const requestCopyLogisticTripAction = () => {
  return {
    type: REQUEST_COPY_LOGISTIC_TRIP,
  };
};

const responseCopyLogisticTripAction = (data, index) => {
  return {
    type: RESPONSE_COPY_LOGISTIC_TRIP,
    data,
    index,
  };
};

const requestCopyLogisticTripFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_LOGISTIC_TRIP_FAILURE,
    errors,
  };
};

const copyLogisticTrip = (options, index) => {
  return (dispatch) => {
    dispatch(requestCopyLogisticTripAction());

    logisticTripsService
      .copyLogisticTrip(options)
      .then((result) => {
        const data = result.data;
        data.unit = null;
        dispatch(responseCopyLogisticTripAction(data, index));
      })
      .catch((error) => {
        dispatch(requestCopyLogisticTripFailureAction(error.response));
      });
  };
};

const REQUEST_ADD_UNIT_LOGISTIC_TRIP = "REQUEST_ADD_UNIT_LOGISTIC_TRIP";
const RESPONSE_ADD_UNIT_LOGISTIC_TRIP = "RESPONSE_ADD_UNIT_LOGISTIC_TRIP";
const REQUEST_ADD_UNIT_LOGISTIC_TRIP_FAILURE = "REQUEST_ADD_UNIT_LOGISTIC_TRIP_FAILURE";

const requestAddUnitLogisticTripAction = () => {
  return {
    type: REQUEST_ADD_UNIT_LOGISTIC_TRIP,
  };
};

const responseAddUnitLogisticTripAction = (data) => {
  return {
    type: RESPONSE_ADD_UNIT_LOGISTIC_TRIP,
    data,
  };
};

const requestAddUnitLogisticTripFailureAction = (errors) => {
  return {
    type: REQUEST_ADD_UNIT_LOGISTIC_TRIP_FAILURE,
    errors,
  };
};

const addUnitLogisticTrip = (unit, tripId) => {
  return (dispatch) => {
    dispatch(requestAddUnitLogisticTripAction());

    logisticTripsService
      .addLogisticTripUnit({ unitId: unit.id, tripId })
      .then((result) => {
        dispatch(responseAddUnitLogisticTripAction(unit));
      })
      .catch((error) => {
        dispatch(requestAddUnitLogisticTripFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_UNIT_LOGISTIC_TRIP = "REQUEST_DELETE_UNIT_LOGISTIC_TRIP";
const RESPONSE_DELETE_UNIT_LOGISTIC_TRIP = "RESPONSE_DELETE_UNIT_LOGISTIC_TRIP";
const REQUEST_DELETE_UNIT_LOGISTIC_TRIP_FAILURE = "REQUEST_DELETE_UNIT_LOGISTIC_TRIP_FAILURE";

const requestDeleteUnitLogisticTripAction = () => {
  return {
    type: REQUEST_DELETE_UNIT_LOGISTIC_TRIP,
  };
};

const responseDeleteUnitLogisticTripAction = () => {
  return {
    type: RESPONSE_DELETE_UNIT_LOGISTIC_TRIP,
  };
};

const requestDeleteUnitLogisticTripFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_UNIT_LOGISTIC_TRIP_FAILURE,
    errors,
  };
};

const deleteUnitLogisticTrip = (unitId, tripId) => {
  return (dispatch) => {
    dispatch(requestDeleteUnitLogisticTripAction());

    logisticTripsService
      .deleteLogisticTripUnit({ unitId, tripId })
      .then((result) => {
        dispatch(responseDeleteUnitLogisticTripAction());
      })
      .catch((error) => {
        dispatch(requestDeleteUnitLogisticTripFailureAction(error.response));
      });
  };
};

const REQUEST_LOGISTIC_TRIPS_GEO = "REQUEST_LOGISTIC_TRIPS_GEO";
const RESPONSE_LOGISTIC_TRIPS_GEO = "RESPONSE_LOGISTIC_TRIPS_GEO";
const REQUEST_LOGISTIC_TRIPS_GEO_FAILURE = "REQUEST_LOGISTIC_TRIPS_GEO_FAILURE";

const requestLogisticTripsGeoAction = () => {
  return {
    type: REQUEST_LOGISTIC_TRIPS_GEO,
  };
};

const responseLogisticTripsGeoAction = (data) => {
  return {
    type: RESPONSE_LOGISTIC_TRIPS_GEO,
    data,
  };
};

const requestLogisticTripsGeoFailureAction = (errors) => {
  return {
    type: REQUEST_LOGISTIC_TRIPS_GEO_FAILURE,
    errors,
  };
};

const getLogisticTripGeoJson = (options = {}) => {
  return (dispatch) => {
    dispatch(requestLogisticTripsGeoAction());

    logisticTripsService
      .getLogisticTripGeoJson(options)
      .then((result) => {
        dispatch(responseLogisticTripsGeoAction(result.data));
      })
      .catch((error) => {
        dispatch(requestLogisticTripsGeoFailureAction(error.response));
      });
  };
};

const REQUEST_UPDATE_LOGISTIC_TRIPS_ALARM = "REQUEST_UPDATE_LOGISTIC_TRIPS_ALARM";
const RESPONSE_UPDATE_LOGISTIC_TRIPS_GEO_ALATM = "RESPONSE_UPDATE_LOGISTIC_TRIPS_GEO_ALATM";
const REQUEST_UPDATE_LOGISTIC_TRIPS_GEO_ALARM_FAILURE = "REQUEST_UPDATE_LOGISTIC_TRIPS_GEO_ALARM_FAILURE";

const requestUpdateTripAlarmAction = () => {
  return {
    type: REQUEST_UPDATE_LOGISTIC_TRIPS_ALARM,
  };
};

const responsetUpdateTripAlarmAction = (data) => {
  return {
    type: RESPONSE_UPDATE_LOGISTIC_TRIPS_GEO_ALATM,
    data,
  };
};

const requestUpdateTripAlarmFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_LOGISTIC_TRIPS_GEO_ALARM_FAILURE,
    errors,
  };
};

const updateLogisticTripAlarm = (tripId, options) => {
  return (dispatch) => {
    dispatch(requestUpdateTripAlarmAction());

    logisticTripsService
      .updateLogisticTripAlarm(tripId, options)
      .then((result) => {
        dispatch(responsetUpdateTripAlarmAction(options));
      })
      .catch((error) => {
        dispatch(requestUpdateTripAlarmFailureAction(error.response));
      });
  };
};

export {
  REQUEST_LOGISTIC_TRIPS,
  RESPONSE_LOGISTIC_TRIPS,
  REQUEST_LOGISTIC_TRIPS_FAILURE,
  getLogisticTrips,
  REQUEST_LOGISTIC_TRIP,
  RESPONSE_LOGISTIC_TRIP,
  REQUEST_LOGISTIC_TRIP_FAILURE,
  getLogisticTrip,
  REQUEST_CREATE_LOGISTIC_TRIP,
  RESPONSE_CREATE_LOGISTIC_TRIP,
  REQUEST_CREATE_LOGISTIC_TRIP_FAILURE,
  createLogisticTrip,
  REQUEST_DELETE_LOGISTIC_TRIP,
  RESPONSE_DELETE_LOGISTIC_TRIP,
  REQUEST_DELETE_LOGISTIC_TRIP_FAILURE,
  deleteLogisticTrip,
  ON_SELECT_LOGISTIC_TRIP,
  selectLogisticTrip,
  REQUEST_UPDATE_LOGISTIC_TRIP,
  RESPONSE_UPDATE_LOGISTIC_TRIP,
  REQUEST_UPDATE_LOGISTIC_TRIP_FAILURE,
  updateLogisticTrip,
  REQUEST_COPY_LOGISTIC_TRIP,
  RESPONSE_COPY_LOGISTIC_TRIP,
  REQUEST_COPY_LOGISTIC_TRIP_FAILURE,
  copyLogisticTrip,
  REQUEST_ADD_UNIT_LOGISTIC_TRIP,
  RESPONSE_ADD_UNIT_LOGISTIC_TRIP,
  REQUEST_ADD_UNIT_LOGISTIC_TRIP_FAILURE,
  addUnitLogisticTrip,
  REQUEST_DELETE_UNIT_LOGISTIC_TRIP,
  RESPONSE_DELETE_UNIT_LOGISTIC_TRIP,
  REQUEST_DELETE_UNIT_LOGISTIC_TRIP_FAILURE,
  deleteUnitLogisticTrip,
  REQUEST_LOGISTIC_TRIPS_GEO,
  RESPONSE_LOGISTIC_TRIPS_GEO,
  REQUEST_LOGISTIC_TRIPS_GEO_FAILURE,
  getLogisticTripGeoJson,
  REQUEST_UPDATE_LOGISTIC_TRIPS_ALARM,
  REQUEST_UPDATE_LOGISTIC_TRIPS_GEO_ALARM_FAILURE,
  RESPONSE_UPDATE_LOGISTIC_TRIPS_GEO_ALATM,
  updateLogisticTripAlarm,
};
